import "./bootstrap";

import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import Datepicker from "flowbite-datepicker/Datepicker";
import moment from "moment";
import * as Sentry from "@sentry/browser";
import { Loader } from "@googlemaps/js-api-loader";
import {
    initGmapsAutocomplete,
    initGmapsMarker,
    initGmapsViewer,
} from "./gmaps";

import './mixpanel-wetopia'

Sentry.init({
    dsn: import.meta.env.SENTRY_LARAVEL_DSN,

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,

    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    integrations: [
        new Sentry.Replay({
            // Additional SDK configuration goes in here, for example:
            // maskAllText: true,
            // blockAllMedia: true,
        }),
    ],
});

Alpine.plugin(focus);
window.Alpine = Alpine;
window.Datepicker = Datepicker;
window.moment = moment;

import "./../../vendor/power-components/livewire-powergrid/dist/powergrid";
import "./../../node_modules/flowbite/dist/flowbite.js";
import "./../../node_modules/flowbite/dist/datepicker.js";
// import './../../node_modules/tw-elements/dist/js/index.min'
import Chart from "chart.js/auto";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import flatpickr from "flatpickr";

const initFlatpickr = () => {
    flatpickr(".flatpickr", {
        enableTime: true,
        dateFormat: "H:i",
        time24hr: true,
    });
};

document.addEventListener("DOMContentLoaded", initFlatpickr);

window.Chart = Chart;
window.ClassicEditor = ClassicEditor;

// Custom Chart JS Plugin
// Show number value after bar in horizontal
Chart.register([
    {
        id: "barChartCustomPlugin1",
        afterDraw: function (chart, args, pluginOptions) {
            const { ctx } = chart;
            ctx.save();
            chart._sortedMetasets[0].data.forEach((bar) => {
                ctx.fillStyle = "#27272A";
                ctx.font = "12px Inter";
                ctx.fillText(bar.$context.raw, bar.x + 6, bar.y + 5);
                ctx.restore();
            });
        },
    },
]);

// Show count and total in center for doughnut chart
Chart.register([
    {
        id: "doughnutChartCustomPlugin1",
        afterDraw: function (chart, args, pluginOptions) {
            const { ctx, data } = chart;
            ctx.save();
            ctx.fillStyle = "#27272A";
            ctx.font = "12px Inter";
            ctx.textAlign = "center";
            ctx.fillText(
                `${data.datasets[0].data[0]}/${data.datasets[0].data.total}`,
                ctx.canvas.clientHeight / 2,
                ctx.canvas.clientWidth / 2 + 2
            );
            ctx.restore();
        },
    },
]);
const apiKey = import.meta.env.VITE_GMAPS_FE_API_KEY;
window.loader = new Loader({
    apiKey,
    version: "weekly",
});

window.initGmapsViewer = initGmapsViewer;
window.initGmapsAutocomplete = initGmapsAutocomplete;
window.initGmapsMarker = initGmapsMarker;

Alpine.start();
